import { useCallback, useMemo } from 'react';
import { ColumnTable, Button } from '@octano/global-ui';
import { StudentRiskItem } from '../types';
import { BadgeStatus } from '../BadgeStatus';
import RiskLevelBadge from '../../RiskLevelBadge';
import { useTexts } from './useTexts';
import { useHistory } from 'react-router';
import { PathsLayouts } from '../../../../../config/routes';

export function useColumns() {
  const texts = useTexts().table;
  const headerTexts = texts.headers;
  const contentTexts = texts.content;

  const history = useHistory();

  const handleShowDetails = useCallback(
    (sessionEnrollmentId: number | string) => {
      history.push(
        `${PathsLayouts.studentWarnings}/student-risk/history/session-enrollment/${sessionEnrollmentId}`,
      );
    },
    [history],
  );
  const columns: ColumnTable<StudentRiskItem>[] = useMemo(() => {
    return [
      {
        headerText: headerTexts.date,
        columnName: 'date',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.session,
        columnName: 'session',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.studentInfo,
        columnName: 'studentInfo',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ value }) => {
          return (
            <div>
              {value.name} ({value.id})
            </div>
          );
        },
      },
      {
        headerText: headerTexts.studyPlan,
        columnName: 'studyPlan',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.campus,
        columnName: 'campus',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.promotion,
        columnName: 'promotion',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.course,
        columnName: 'course',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: headerTexts.riskLevel,
        columnName: 'riskLevel',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ value }) =>
          value ? <RiskLevelBadge riskLevel={value} /> : '-',
      },
      {
        headerText: headerTexts.isActive,
        columnName: 'isActive',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ value }) => {
          return <BadgeStatus active={value} />;
        },
      },
      {
        headerText: headerTexts.conditional,
        columnName: 'conditional',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ value }) => {
          return value
            ? contentTexts.conditionality.yes
            : contentTexts.conditionality.no;
        },
      },
      {
        headerText: headerTexts.action,
        columnName: 'action',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ row }) => {
          return (
            <Button
              size="sm"
              text={contentTexts.detailButton}
              onClick={() => handleShowDetails(row.sessionEnrollmentId)}
            />
          );
        },
      },
    ];
  }, [headerTexts, contentTexts, handleShowDetails]);

  return columns;
}
